module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/quotations/quotations.html
// module id = 457
// module chunks = 0